import { Schema } from "effect";
import { SupportTicketId } from "../../ids/definitions";

export const TypingNotification = Schema.Struct({
  _tag: Schema.Literal("typing"),
  supportTicketId: SupportTicketId,
  userId: Schema.String,
});
export type TypingNotification = typeof TypingNotification.Type;

export const PresenceViewingNotification = Schema.Struct({
  _tag: Schema.Literal("presenceViewing"),
  supportTicketId: SupportTicketId,
  userId: Schema.String,
});
export type PresenceViewingNotification =
  typeof PresenceViewingNotification.Type;

export const PresenceClearedActivity = Schema.Literal(
  "viewing",
  "typing",
  "all",
);
export type PresenceClearedActivity = typeof PresenceClearedActivity.Type;

export const PresenceClearedNotification = Schema.Struct({
  _tag: Schema.Literal("presenceCleared"),
  supportTicketId: SupportTicketId,
  userId: Schema.String,
  activity: PresenceClearedActivity,
});
export type PresenceClearedNotification =
  typeof PresenceClearedNotification.Type;

export const PresenceNotification = Schema.Union(
  TypingNotification,
  PresenceViewingNotification,
  PresenceClearedNotification,
);
export type PresenceNotification = typeof PresenceNotification.Type;

export const PresenceNotificationJson = Schema.parseJson(PresenceNotification);

export type PresenceNotificationTag = PresenceNotification["_tag"];

export const NotifyTypingInput = Schema.Struct({
  supportTicketId: SupportTicketId,
  userId: Schema.String,
  name: Schema.String,
});
export type NotifyTypingInput = typeof NotifyTypingInput.Type;

export const NotifyPresenceInput = Schema.Union(
  Schema.Struct({
    event: Schema.Literal("presence.viewing"),
    supportTicketId: SupportTicketId,
    userId: Schema.String,
  }),
  Schema.Struct({
    event: Schema.Literal("presence.typing"),
    supportTicketId: SupportTicketId,
    userId: Schema.String,
  }),
  Schema.Struct({
    event: Schema.Literal("presence.cleared"),
    userId: Schema.String,
    supportTicketId: Schema.optional(SupportTicketId),
    activity: Schema.optional(Schema.Literal("typing", "viewing", "all")),
  }),
);
export type NotifyPresenceInput = typeof NotifyPresenceInput.Type;
